/* BW market currency display converter.
   Replaces BUCKS: currency is decided by the SERVED MARKET (Shopify.country),
   so it always matches the price tier the server rendered — like Magento store views.
   Rates are Magento's exact configured rate table (1 EGP = X currency).
   Converts display only; cart/checkout remain EGP by design.
   Idle while BUCKS app is active to avoid double conversion. */
(function () {
  'use strict';

  var RATES = {
    SAR: 0.075357, KWD: 0.006218, QAR: 0.073147, AED: 0.073800,
    USD: 0.020095, GBP: 0.014999, IQD: 26.266927, TRY: 0.948221,
    TZS: 52.961855, ZAR: 0.330659
  };
  var COUNTRY_CUR = {
    SA: 'SAR', KW: 'KWD', QA: 'QAR', AE: 'AED', US: 'USD', GB: 'GBP',
    IQ: 'IQD', TR: 'TRY', TZ: 'TZS', ZA: 'ZAR', EG: 'EGP'
  };
  var SYM = {
    SAR: 'SR', KWD: 'KD', QAR: 'QR', AED: 'AED', USD: '$', GBP: '£',
    IQD: 'IQD', TRY: '₺', TZS: 'TSh', ZAR: 'R'
  };
  var PREFIX = { USD: true, GBP: true };

  function country() {
    if (window.Shopify && Shopify.country) return Shopify.country;
    var m = location.pathname.match(/^\/(?:en|ar)-([a-z]{2})(\/|$)/);
    if (m) return m[1].toUpperCase() === 'UK' ? 'GB' : m[1].toUpperCase();
    return 'EG';
  }

  var CUR = COUNTRY_CUR[country()] || 'EGP';
  if (CUR === 'EGP') return; // Egypt: prices are already EGP, nothing to do
  var RATE = RATES[CUR];
  if (!RATE) return;

  function fmtNum(v) {
    // whole numbers only — clean prices like Magento's display (284, not 283.93)
    return Math.round(v).toLocaleString('en-US');
  }
  function fmtMoney(egp) {
    var v = egp * RATE;
    return PREFIX[CUR] ? SYM[CUR] + fmtNum(v) : fmtNum(v) + ' ' + SYM[CUR];
  }
  function parseEgp(text) {
    var m = String(text).replace(/[٫٬]/g, '').match(/[\d][\d,\.]*/);
    if (!m) return null;
    var n = parseFloat(m[0].replace(/,/g, ''));
    return isNaN(n) ? null : n;
  }

  function convertEl(el) {
    if (el.getAttribute('data-bw-cur') === CUR) return;
    var egp = parseFloat(el.getAttribute('data-bw-egp'));
    if (isNaN(egp)) {
      egp = parseEgp(el.textContent);
      if (egp === null) return;
      el.setAttribute('data-bw-egp', egp);
    }
    el.textContent = fmtMoney(egp);
    el.setAttribute('data-bw-cur', CUR);
  }

  function convertOption(opt) {
    if (opt.getAttribute('data-bw-cur') === CUR) return;
    var orig = opt.getAttribute('data-bw-label') || opt.textContent;
    opt.setAttribute('data-bw-label', orig);
    var parts = orig.split('—'); // "title — LE 51,840.00"
    if (parts.length < 2) return;
    var egp = parseEgp(parts[parts.length - 1]);
    if (egp === null) return;
    parts[parts.length - 1] = ' ' + fmtMoney(egp);
    opt.textContent = parts.join('—');
    opt.setAttribute('data-bw-cur', CUR);
  }

  var scheduled = false;
  function convertAll() {
    scheduled = false;
    // stand down while BUCKS theme extension is live (double-conversion guard)
    if (window.bucksCC && window.bucksCC.themeAppExtension) return;
    var els = document.querySelectorAll('span.money');
    for (var i = 0; i < els.length; i++) convertEl(els[i]);
    var opts = document.querySelectorAll('.bw-brow__select option');
    for (var j = 0; j < opts.length; j++) convertOption(opts[j]);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(convertAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
